<template>
<div class="box">
  <downLoadApp></downLoadApp>
  <footerPage></footerPage>
</div>
</template>

<script>
import downLoadApp from "@/components/userInfo/downLoadApp";
import footerPage from "@/components/userInfo/footer";
export default {
  name: "downLoad",
  components:{downLoadApp,footerPage}
}
</script>

<style scoped>
::v-deep .footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>